import {
    faAddressBook,
    faBuilding,
    faEnvelope,
    faGear,
    faSkull,
    faStar,
    faUser
} from '@fortawesome/free-solid-svg-icons';
import {faListTree, faMemo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useMemo } from 'react';
import styles from './EntityIcon.module.sass';

const EntityIcon = ({
    entity, size
}: Props) => {
    const icon = useMemo(() => {
        switch (entity) {
            case 'offer':
                return faStar;
            case 'candidate':
                return faUser;
            case 'business_unit':
                return faBuilding;
            case 'vacancy':
                return faMemo;
            case 'contact':
                return faAddressBook;
            case 'mail':
                return faEnvelope;
            case 'options':
                return faListTree;
            case 'setting':
                return faGear
            default:
                return faSkull;
        }
    }, [entity]);

    const iconSize = useMemo(() => {
        switch (size) {
            case 'xlarge':
                return '5x';
            case 'large':
                return '3x';
            case 'medium':
            default:
                return '2x';
        }
    }, [size]);

    if (!icon || !iconSize) return <></>; 

    return <div className={`${styles['entityicon']} ${styles['entityicon__entity--'+(entity||'setting')]} ${styles['entityicon__size--'+(size||'medium')]}`}>
        <FontAwesomeIcon icon={icon} size={iconSize} />
    </div>
}

interface Props {
    entity: 'offer' | 'candidate' | 'vacancy' | 'business_unit' | 'contact' | 'setting' | 'mail' | 'options'
    size?: 'xlarge' | 'large' | 'medium' | 'small'
}

export default EntityIcon;